import React from "react"
import PropTypes from "prop-types"

/**
 * Paso 2 — Equipo Médico
 * Médico tratante, teléfono y anestesiología
 */
const StepMedico = ({
    // Médico tratante
    cedulaHadError,
    cedula,
    onChangeCedula,
    onFocusDiagnostico,
    onBlurDiagnostico,
    seMuestraMedico,
    handleCancelarMedicoClick,
    handleAgregarMedicoClick,
    resultMedicoList,
    handleCedulaChange,
    MAX,
    // Teléfono
    telefonoHadError,
    telefono,
    onChangeTelefono,
    // Anestesiólogo
    nombreAnestesiologoHadError,
    onChangeTipoAnestesiologo,
    isAnestesiologoExterno,
    nombreAnestesiologo,
    onChangeNombreAnestesiologo,
    seMuestraMedicoAnestesiologo,
    handleCancelarMedicoAnestesiologoClick,
    handleAgregarAnestesiologoClick,
    resultAnestesiologoList,
    handleAnestesiologoChange,
}) => (
    <div className="rq-panel">

        {/* Médico tratante */}
        <div className={cedulaHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorMedico">
            <label className="rq-label">Nombre del médico tratante<span className="rq-required">*</span></label>
            <div className="rq-content">
                <div className="rq-autocomplete">
                    <textarea
                        id="cedula"
                        name="cedula"
                        className="rq-textarea"
                        value={cedula}
                        onChange={onChangeCedula}
                        onFocus={onFocusDiagnostico}
                        onBlur={onBlurDiagnostico}
                        rows="2"
                        placeholder="Escriba el nombre para buscar..."
                        maxLength={MAX.nombre}
                    />
                    {seMuestraMedico && (
                        <span className="rq-clear" onClick={handleCancelarMedicoClick()}>✕</span>
                    )}
                </div>
                <p className="rq-link-btn" onClick={handleAgregarMedicoClick()}>+ Nuevo médico</p>
                {resultMedicoList.length > 0 && (
                    <ul className="rq-suggestions">
                        {resultMedicoList.map(res => (
                            <li key={res.id} onMouseDown={() => handleCedulaChange(res.Nombre)}>
                                {res.Nombre}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>

        {/* Teléfono */}
        <div className={telefonoHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorTelefonoMedico">
            <label className="rq-label">Teléfono del médico tratante<span className="rq-required">*</span></label>
            <div className="rq-content">
                <input
                    type="text"
                    id="telefono"
                    name="telefono"
                    className="rq-input"
                    value={telefono}
                    onChange={onChangeTelefono}
                    placeholder="10 dígitos"
                    maxLength={MAX.telefono}
                />
            </div>
        </div>

        {/* Anestesiólogo */}
        <div className={nombreAnestesiologoHadError ? "rq-field rq-field--error" : "rq-field"} id="contenedorNombreAnestesiologo">
            <label className="rq-label">Tipo de anestesiólogo<span className="rq-required">*</span></label>
            <div className="rq-content rq-radio-group" onChange={onChangeTipoAnestesiologo}>
                <label className="rq-radio-item"><input type="radio" value="Staff" name="anestesiologo"/> Anestesiólogo Staff</label>
                <label className="rq-radio-item"><input type="radio" value="Externo" name="anestesiologo"/> Anestesiólogo Externo</label>
                <label className="rq-radio-item"><input type="radio" value="No se cuenta con la información" name="anestesiologo"/> No se cuenta con la información</label>
            </div>
            {isAnestesiologoExterno && (
                <>
                    <div className="rq-content">
                        <p className="rq-hint">Nombre del anestesiólogo externo</p>
                        <div className="rq-autocomplete">
                            <textarea
                                id="nombreAnestesiologo"
                                name="nombreAnestesiologo"
                                className="rq-textarea"
                                value={nombreAnestesiologo}
                                onChange={onChangeNombreAnestesiologo}
                                rows="2"
                                placeholder="Buscar anestesiólogo..."
                                maxLength={MAX.nombre}
                            />
                            {seMuestraMedicoAnestesiologo && (
                                <span className="rq-clear" onClick={handleCancelarMedicoAnestesiologoClick()}>✕</span>
                            )}
                        </div>
                        <p className="rq-link-btn" onClick={handleAgregarAnestesiologoClick()}>+ Nuevo anestesiólogo</p>
                        {resultAnestesiologoList.length > 0 && (
                            <ul className="rq-suggestions">
                                {resultAnestesiologoList.map(res => (
                                    <li key={res.id} onMouseDown={() => handleAnestesiologoChange(res.Nombre)}>
                                        {res.Nombre}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </>
            )}
        </div>

    </div>
)

export default StepMedico

StepMedico.propTypes = {
    // Médico tratante
    cedulaHadError:                       PropTypes.bool.isRequired,
    cedula:                               PropTypes.string.isRequired,
    onChangeCedula:                       PropTypes.func.isRequired,
    onFocusDiagnostico:                   PropTypes.func.isRequired,
    onBlurDiagnostico:                    PropTypes.func.isRequired,
    seMuestraMedico:                      PropTypes.bool.isRequired,
    handleCancelarMedicoClick:            PropTypes.func.isRequired,
    handleAgregarMedicoClick:             PropTypes.func.isRequired,
    resultMedicoList:                     PropTypes.array.isRequired,
    handleCedulaChange:                   PropTypes.func.isRequired,
    MAX:                                  PropTypes.object.isRequired,
    // Teléfono
    telefonoHadError:                     PropTypes.bool.isRequired,
    telefono:                             PropTypes.string.isRequired,
    onChangeTelefono:                     PropTypes.func.isRequired,
    // Anestesiólogo
    nombreAnestesiologoHadError:          PropTypes.bool.isRequired,
    onChangeTipoAnestesiologo:            PropTypes.func.isRequired,
    isAnestesiologoExterno:               PropTypes.bool.isRequired,
    nombreAnestesiologo:                  PropTypes.string.isRequired,
    onChangeNombreAnestesiologo:          PropTypes.func.isRequired,
    seMuestraMedicoAnestesiologo:         PropTypes.bool.isRequired,
    handleCancelarMedicoAnestesiologoClick: PropTypes.func.isRequired,
    handleAgregarAnestesiologoClick:      PropTypes.func.isRequired,
    resultAnestesiologoList:              PropTypes.array.isRequired,
    handleAnestesiologoChange:            PropTypes.func.isRequired,
}